import { render } from "./LanguageSelect.vue?vue&type=template&id=54a45c5e&scoped=true&ts=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=ts"
export * from "./LanguageSelect.vue?vue&type=script&lang=ts"

import "./LanguageSelect.vue?vue&type=style&index=0&id=54a45c5e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a45c5e"]])

export default __exports__